import React, { useState, useEffect, useRef } from 'react';
import { MdPrint, MdKeyboardArrowDown } from 'react-icons/md';
import apiService from "../../../config";
import { Download, Printer, Upload } from 'lucide-react';
import { FileText } from 'lucide-react';
import { useSignature } from '../../../DigitalSignature/UseSignatue';
import SignaturePad from '../../../DigitalSignature/SignaturePad';

const HighwayAnusuchi3 = ({ onBack, setSubComponent }) => {
  const certificateContentRef = useRef();
  const [loading, setLoading] = useState(true);
  const [regionalInchargeName, setRegionalInchargeName] = useState("");
  const [regionalInchargeDesignation, setRegionalInchargeDesignation] = useState("");
  const [selectedCertificate, setSelectedCertificate] = useState('demarcation');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedProposalId, setSelectedProposalId] = useState(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("idle");
  const [uploadError, setUploadError] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);

  const [showSignaturePad, setShowSignaturePad] = useState(false);
      const [pdfForSigning, setPdfForSigning] = useState(null);
      const { signDocument } = useSignature();

  const findProposalId = (projectObj) => {
    if (!projectObj) return null;

    const possibleKeys = [
      'acquisition_proposal_no',
      'land_acquisition_no',
      'proposal_id',
      'proposalId',
      'proposal',
      'id',
      'project_id'
    ];

    for (const key of possibleKeys) {
      if (projectObj[key] !== undefined && projectObj[key] !== null && projectObj[key] !== '') {
        // console.log(`Found proposalId in key: ${key}, value: ${projectObj[key]}`);
        return projectObj[key];
      }
    }

    // console.log('Available keys in project object:', Object.keys(projectObj));
    // console.log('Project object values:', projectObj);
    return null;
  };
  const handleUploadSignature = async (file) => {
    try {
      setUploadStatus("uploading");
      setUploadError("");

      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
      const projectIdFromStorage = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem('currentProposalId') || findProposalId(selectedProject);

      if (!projectIdFromStorage || !proposalId) {
        setUploadStatus("error");
        setUploadError("Missing projectId or proposalId");
        alert("Missing projectId or proposalId");
        return;
      }

      const BRIDGE_URL = "http://127.0.0.1:8000";

      // Show dialog first (always open modal)
      const signatureParams = await showDigitalSignatureDialog();
      if (!signatureParams) {
        setUploadStatus("idle");
        return; // User cancelled
      }

      // Check bridge app status AFTER modal
      try {
        const healthCheck = await fetch(`${BRIDGE_URL}/health`, { method: "GET" });
        if (!healthCheck.ok) {
          throw new Error("Bridge app not accessible");
        }
      } catch (error) {
        setUploadStatus("error");
        setUploadError("Digital signature bridge app is not running. Please start it first.");
        alert("Digital signature bridge app is not running. Please start it first.");
        return;
      }

      // Build FormData according to FastAPI API
      const formData = new FormData();
      formData.append("pdf_file", file);
      formData.append("token_name", signatureParams.tokenName);
      formData.append("pin", signatureParams.pin);
      formData.append("pages", signatureParams.pages); // ✅ string (e.g. "all" or "1-3,5")
      formData.append("position", signatureParams.position); // ✅ "Left" / "Right"
      formData.append("place_text", signatureParams.placeText || "");

      const bridgeResponse = await fetch(`${BRIDGE_URL}/sign-pdf/`, {
        method: "POST",
        body: formData,
      });

      if (!bridgeResponse.ok) {
        const errorData = await bridgeResponse.json().catch(() => ({ detail: "Unknown error" }));
        throw new Error(errorData.detail || `Bridge app error: ${bridgeResponse.status}`);
      }

      const signedPdfBlob = await bridgeResponse.blob();
      const signedPdfFile = new File([signedPdfBlob], `signed_${file.name}`, { type: "application/pdf" });

      const serverResponse = await apiService.postAddSignaturePDF(
        projectIdFromStorage,
        proposalId,
        "anusuchi2",
        signedPdfFile
      );

      if (serverResponse?.status === 200) {
        setUploadStatus("success");
        alert("PDF digitally signed and uploaded successfully!");

        const sectionRes = await apiService.getSectionFile(projectIdFromStorage, proposalId, "anusuchi2");
        if (sectionRes?.isSignAvailable && sectionRes?.data?.length > 0) {
          setPreviewUrl(sectionRes.data[0].file_path);
        }
      } else {
        setUploadStatus("error");
        setUploadError(`Failed to upload signed PDF: ${serverResponse?.message || "Unknown error"}`);
        alert(`Failed to upload signed PDF: ${serverResponse?.message || "Unknown error"}`);
      }

    } catch (error) {
      setUploadStatus("error");
      setUploadError(error.message);
      console.error("Digital signature error:", error);

      if (error.message.includes("PIN is incorrect")) {
        alert("The provided PIN is incorrect. Please try again.");
      } else if (error.message.includes("token found")) {
        alert("No PKCS#11 token found. Please connect your digital signature device.");
      } else if (error.message.includes("Bridge app not running")) {
        alert("Digital signature bridge app is not running. Please start it first.");
      } else {
        alert(`Error during digital signing: ${error.message}`);
      }
    }
  };


  // Updated dialog to match Python backend
  const showDigitalSignatureDialog = () => {
    return new Promise((resolve) => {
      const modal = document.createElement("div");
      modal.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(0,0,0,0.5); display: flex; align-items: center;
      justify-content: center; z-index: 1000;
    `;

      const dialog = document.createElement("div");
      dialog.style.cssText = `
      background: white; padding: 20px; border-radius: 8px;
      max-width: 400px; width: 90%;
    `;

      dialog.innerHTML = `
      <h3 style="margin-top: 0;">Digital Signature Parameters</h3>
      <form id="signatureForm">
        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">Token Name:</label>
          <select id="tokenName" required 
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
            <option value="">Select Token</option>
            <option value="ProxKey">ProxKey</option>
            <option value="ePass2003 Auto">ePass2003 Auto</option>
            <option value="Moser Baer">Moser Baer</option>
            <option value="Safenet/Gemalto">Safenet/Gemalto</option>
          </select>
        </div>

        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">PIN:</label>
          <input type="password" id="pin" required 
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
        </div>

        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">Pages (e.g., "all", "1-3,5"):</label>
          <input type="text" id="pages" value="all" required
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
        </div>

        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">Signature Position:</label>
          <select id="position" 
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
            <option value="Right">Right</option>
            <option value="Left">Left</option>
          </select>
        </div>

        <div style="margin-bottom: 20px;">
          <label style="display:block; margin-bottom:5px;">Place Text (Optional):</label>
          <input type="text" id="placeText" placeholder="e.g., Mumbai, India"
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
        </div>

        <div style="display:flex; gap:10px; justify-content:flex-end;">
          <button type="button" id="cancelBtn" 
            style="padding:8px 16px; border:1px solid #ccc; background:white; border-radius:4px; cursor:pointer;">
            Cancel
          </button>
          <button type="submit" 
            style="padding:8px 16px; border:none; background:#007bff; color:white; border-radius:4px; cursor:pointer;">
            Sign PDF
          </button>
        </div>
      </form>

    `;

      modal.appendChild(dialog);
      document.body.appendChild(modal);

      const form = dialog.querySelector("#signatureForm");
      const cancelBtn = dialog.querySelector("#cancelBtn");

      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const params = {
          tokenName: dialog.querySelector("#tokenName").value,
          pin: dialog.querySelector("#pin").value,
          pages: dialog.querySelector("#pages").value.trim() || "all",
          position: dialog.querySelector("#position").value,
          placeText: dialog.querySelector("#placeText").value,
        };
        document.body.removeChild(modal);
        resolve(params);
      });

      cancelBtn.addEventListener("click", () => {
        document.body.removeChild(modal);
        resolve(null);
      });

      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          document.body.removeChild(modal);
          resolve(null);
        }
      });
    });
  };

  // const handleFileUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setSignatureFile(file);
  //     // setPreviewUrl(URL.createObjectURL(file));
  //     handleUploadSignature(file);
  //   }
  // };

  const handleUploadedFile = (e) => {
  const file = e.target.files[0];

  if (!file) return;

  // ✅ open uploaded file in signature modal
  setPdfForSigning(file);
  setShowSignaturePad(true);
};


  const handleViewFile = () => {
    if (previewUrl) {
      window.open(previewUrl, "_blank");
    }
  }
  const [formData, setFormData] = useState({
    project_name: '',
    village: '',
    taluka: '',
    district: '',
    proposal_no_name: '',
    amount: '',
    officer1_name: '',
    officer1_designation: '',
    officer2_name: '',
    officer2_designation: '',
    date: new Date().toISOString().split('T')[0],
    place: ''
  });
  const [editMode, setEditMode] = useState({
    description: false,
    benefit: false,
  });

  // Certificate options for dropdown
  const certificateOptions = [
    // { value: 'all', label: 'सर्व प्रमाणपत्रे (All Certificates)' },
    { value: 'demarcation', label: 'भूमि सीमांकन प्रमाणपत्र' },
    { value: 'no_previous', label: 'पूर्वी भूसंपादन न झाल्याबाबत प्रमाणपत्र' },
    { value: 'not_cancelled', label: 'प्रस्ताव रद्द होणार नसल्याचे प्रमाणपत्र' },
    { value: 'survey_fee', label: 'संयुक्त मोजणी शुल्क शासन जमा करणे बाबत प्रमाणपत्र' },
    { value: 'financial', label: 'आर्थिक तरतूदीचे प्रमाणपत्र' },
    { value: 'public_purpose', label: 'सार्वजनिक प्रयोजनाच्या स्वरुपाबाबत विवरण' },
    { value: 'religious', label: 'धार्मिक स्थळांबाबत प्रमाणपत्र' },
    { value: 'railway', label: 'रेल्वे सीमा बाबत प्रमाणपत्र' },
    { value: 'public_rights', label: 'सार्वजनिक मार्गाधिकार प्रमाणपत्र' }
  ];

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const userData = JSON.parse(localStorage.getItem("userData"));
        const project = JSON.parse(localStorage.getItem("selectedProject"));
        const projectId = project?.id || project?.project_id;
        const proposalId = userData?.default_proposal || userData?.proposal_id;

        // Get officer information from selectedProposal localStorage
        // const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
        // if (storedProposal?.acquisition_regional_incharge_name) {
        //   setRegionalInchargeName(storedProposal.acquisition_regional_incharge_name);
        // }
        // if (storedProposal?.acquisition_regional_incharge_designation) {
        //   setRegionalInchargeDesignation(storedProposal.acquisition_regional_incharge_designation);
        // }

        if (projectId && proposalId) {
          setSelectedProposalId(proposalId);  // ✅ store proposalId here
          const result = await apiService.getProposalById(projectId, proposalId);
          if (result && result.status === 200) {
            const proposal = Array.isArray(result.data)
              ? result.data[0]
              : result.data;
            const today = new Date();
            setRegionalInchargeName(
              proposal?.acquisition_regional_incharge_name || ""
            );
            setRegionalInchargeDesignation(
              proposal?.acquisition_regional_incharge_designation || ""
            );

            setFormData({
              project_name: project.project_name || '',
              village: proposal.village_name || '',
              taluka: proposal.taluka_name || '',
              district: proposal.dist_name || '',
              proposal_no_name: proposal.acquisition_proposal_no || '',
              amount: proposal.acquisition_area || '',
              officer1_name: proposal?.acquisition_regional_incharge_name || '',
              officer1_designation: proposal?.acquisition_regional_incharge_designation || '',
              officer2_name: proposal?.acquisition_incharge_name || '',
              officer2_designation: proposal?.acquisition_incharge_designation || '',
              date: proposal?.acquisition_proposal_date
                ? proposal.acquisition_proposal_date
                : new Date().toISOString().split('T')[0],
              place: proposal.acquisition_incharge_address || '',
              project_description: proposal.project_description || '',
              project_social_benfit: proposal.project_social_benfit || ''
            });
          }
        }
      } catch (error) {
        console.error("Error loading proposal data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);


  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handlePrintView = () => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('कृपया पॉपअप अनुमती द्या.');
      return;
    }

    const content = certificateContentRef.current.innerHTML;
    const selectedOption = certificateOptions.find(opt => opt.value === selectedCertificate);
    const title = selectedOption ? selectedOption.label : 'प्रस्ताव प्रमाणपत्र';

    const printHTML = `
  <!DOCTYPE html>
  <html lang="mr">
  <head>
    <meta charset="UTF-8">
    <title>${title}</title>
    <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
    <style>
      @page {
        size: A4 portrait;
        margin-top: 0.19in;
        margin-bottom: 0.25in;
        margin-left: 0.81in;
        margin-right: 0.5in;
      }

      body {
        font-family: 'Noto Sans Devanagari', 'Mangal', 'Arial', sans-serif;
        color: black;
        background: white;
      }

      .certificate {
        background: white;
        page-break-inside: avoid;
        margin-bottom: 30px;
        padding: 20px;
      }

      .text-center {
        text-align: center !important;
      }

      .text-justify {
        text-align: justify !important;
      }

      .underline {
        text-decoration: underline !important;
      }

      .certificate-header {
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 10px;
        text-decoration: underline;
      }

      .main-header {
        text-align: center;
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 10px;
      }

      .certificate-content {
        text-align: justify;
        line-height: 2;
        margin: 20px 0;
      }

      .signature-section {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
        page-break-inside: avoid;
      }

      .signature-block {
        text-align: center;
      }

      .underline-field {
        display: inline-block;
        border-bottom: 1px solid black;
        min-width: 80px;
        text-align: center;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin: 20px 0;
      }

      td, th {
        border: 1px solid black;
        padding: 8px;
        text-align: left;
      }

      @media print {
        body { -webkit-print-color-adjust: exact; }
        .print-hidden { display: none !important; }
      }
    </style>
  </head>
  <body>
    ${content}
    <script>
      window.onload = function() {
        window.focus();
        window.print();
      };
    </script>
  </body>
  </html>
  `;

    printWindow.document.write(printHTML);
    printWindow.document.close();
  };

  // Loader display
  if (loading) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex justify-center items-center h-80">
          <div className="text-center animate-float">
            <div className="inline-flex relative">
              <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
              <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
              </div>
            </div>
            <p className="text-gray-400 mt-4">प्रमाणपत्र लोड करत आहे...</p>
          </div>
        </div>
      </div>
    );
  }

  // Individual certificate components
  const renderDemarcationCertificate = () => (
    <div className="p-6 mb-8">
      {/* Top header */}

      <h3 className="text-center font-semibold mb-2">परिशिष्ट - 3</h3>
      {/* <p className="text-center mb-2" style={{ fontWeight: "bold" }}>
      प्रस्तावामध्ये समाविष्ट खाजगी जमिनींचा तपशील
    </p> */}
      <h3 className="text-center mb-2" style={{ fontWeight: "bold" }}>
        प्रकल्प नाव: {formData.project_name} | प्रस्ताव नाव: {formData.proposal_no_name}
      </h3>
      <p className="text-center mb-2" style={{ fontWeight: "bold" }}>
        मौजे : {formData.village} तालुका : {formData.taluka} जिल्हा : {formData.district}
      </p>

      <div className="certificate-header text-xl font-bold text-center underline mb-6">
        प्रमाणपत्र
      </div>
      <div className="certificate-content text-justify leading-8">
        <p>प्रमाणित करण्यात येते की,
          <span>{formData.project_name}</span> या प्रकल्पाच्या आखणीमध्ये समाविष्ट असलेल्या प्रस्तावित जमिनीचे सीमांकन करण्यात आले आहे. प्रस्तावित जमिनीचा ताबा खाजगी वाटाघाटीने किंवा इतर कोणत्याही मार्गाने घेतलेला नाही.
        </p>
        <p>
          प्रकल्पाच्या आखणीमध्ये समाविष्ट वन जमिनी वन विभागाकडून हस्तांतरीत करण्याबाबत आणि त्याप्रमाणे आवश्यक कार्यवाही प्रादेशिक विभाग/प्राधिकरण/महामंडळाच्या वतीने स्वतंत्ररीत्या कार्यान्वित करण्यात येत आहे.
        </p>
        <p>
          प्रकल्पाच्या आखणीमध्ये समाविष्ट शासकीय जमिनी /इतर विभागांच्या जमिनी महामंडळास हस्तांतरीत करण्याबाबत आणि त्याप्रमाणे आवश्यक कार्यवाही प्रादेशिक विभाग/प्राधिकरण/महामंडळाच्या वतीने स्वतंत्ररीत्या कार्यान्वित करण्यात येत आहे.
        </p>
        <p>
          सदरचा प्रस्ताव यापूर्वी प्रादेशिक विभाग/प्राधिकरण/महामंडळामार्फत दाखल केलेला नाही.
        </p>
      </div>
      <div className="mt-8">
        <div className="mb-4">
          दिनांक :- <span>
            {formatDate(formData.date || new Date().toISOString().split("T")[0])}
          </span>
        </div>
        <div className="mb-6">
          ठिकाण :- <span>{formData.place}</span>
        </div>
      </div>
      <div className="signature-section flex justify-between mt-12">

        <div className="signature-block text-center">
          <div className="mb-2">({formData.officer1_name})</div>
          <div>{formData.officer1_designation}</div>
        </div>
        <div className="signature-block text-center">
          <div className="mb-2">({formData.officer2_name})</div>
          <div>{formData.officer2_designation}</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 p-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8 border border-gray-200">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-800 mb-2">प्रस्ताव प्रमाणपत्र</h1>
              <p className="text-gray-600">भूमि सीमांकन प्रमाणपत्र</p>
            </div>

            <div className="flex flex-wrap gap-3 items-center">

              <button className="relative">
                <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
                  <Upload size={18} />
                  <span>Upload Signature</span>
                  <input
                    type="file"
                    accept="application/pdf,image/*"
                    className="hidden"
                    onChange={handleUploadedFile}
                  />
                </label>
              </button>
              <button
                onClick={handlePrintView}
                className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-300 shadow-lg hover:shadow-green-200"
              >
                <MdPrint size={20} />
                <span>प्रिंट करा</span>
              </button>
            </div>
          </div>
        </div>

        {/* Certificate Document */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
          <div ref={certificateContentRef}>
            {renderDemarcationCertificate()}
          </div>
        </div>
      </div>

{showSignaturePad && pdfForSigning && (
  <SignaturePad
    pdfFile={pdfForSigning}
    onSign={(signaturesArray) => {
      setShowSignaturePad(false);

      signDocument(pdfForSigning, signaturesArray).then(async (signedPdf) => {
        const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
        const projectId = selectedProject?.id || selectedProject?.project_id;
        const proposalId = localStorage.getItem("currentProposalId");

        await apiService.postAddSignaturePDF(
          projectId,
          proposalId,
          "parishisht1",
          signedPdf
        );

        const sectionRes = await apiService.getSectionFile(
          projectId,
          proposalId,
          "parishisht1"
        );

        if (sectionRes?.isSignAvailable) {
          setPreviewUrl(sectionRes.data[0].file_path);
        }

        setPdfForSigning(null);
      });
    }}
    onCancel={() => {
      setShowSignaturePad(false);
      setPdfForSigning(null);
    }}
  />
)}

    </div>
  );

};

export default HighwayAnusuchi3;